
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Alert,
  Autocomplete,
  Button,
  CheckboxField,
  Flex,
  Icon,
  Loader,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  View} from "@aws-amplify/ui-react";
import { assignTaskAPI, getTaskUserListAPI, getUsersListAPI } from "../../data/api";
import TaskCard from "../task/TaskCard";
import { getUserRoleLabel } from "@/data/interfaces";
import { MdEdit, MdLock, MdLockOpen } from "react-icons/md";
import { NavLink } from "react-router-dom";
import users from ".";
import { format } from "date-fns";
import { Modal } from "react-bootstrap";

const TaskAssignModal = (props) => {
// assign tasks
  const [loadingAssign, setLoadingAssign] = useState(false);
  const [errorAssign, setErrorAssign] = useState(false);

  // load operatori list
  const [operatori, setOperatori] = useState([]);
  const [loadingOperatori, setLoadingOperatori] = useState(true);
  const [errorOperatori, setErrorOperatori] = useState(false);
  const [searchOperatoreValue, setSearchOperatoreValue] = useState('');
  const [operatoreValue, setOperatoreValue] = useState(undefined);
  const getOperatoriList = async () => {
    setLoadingOperatori(true)
    setErrorOperatori(false);
    try {
      const usersList = await getUsersListAPI();
      setOperatori(usersList)
      setLoadingOperatori(false);
    } catch (e) {
      console.log('Could not load users list: ', e);
      setErrorOperatori(true);
      setLoadingOperatori(false);
    }
  };

  const assignTask = async () => {
    try{
      setLoadingAssign(true);
      setErrorAssign(false);
      await assignTaskAPI(props.user, operatoreValue, props.tasks ?? []);
      setLoadingAssign(false);
      props.onAssign();
    } catch (e) {
      console.log('Create task failed ', e);
      setErrorAssign(true);
      setLoadingAssign(false);
    }
  };

  useEffect(() => {
    getOperatoriList();
  }, []);
  
  return (
    <>
    {operatoreValue === undefined ? 
        <View>
            {props.type === 'all' ? 
            <p>Selezionare un utente a cui riassegnare tutti i task attualmente assegnati a <b>{props.user}</b>:</p> :
            <p>Selezionare un utente a cui riassegnare i task selezionati attualmente assegnati a <b>{props.user}</b>:</p>}
            {
            errorOperatori ? <Alert variation="error">Errore nel caricamento della lista utenti</Alert> : 
            <Autocomplete
                label={"Cerca utente"}
                isLoading={loadingOperatori}
                value={searchOperatoreValue}
                onChange={(e) => setSearchOperatoreValue(e.target.value)}
                onClear={() => setSearchOperatoreValue('')}
                onSelect={(e) => setOperatoreValue(e.id)}
                options={operatori.filter(o => o.username !== props.user).map((o) => {return {id: o.username, label: o.username}})}
                placeholder="Cerca utente..."
                menuSlots={{
                LoadingIndicator: (
                    <Flex alignItems="center" gap="0.25rem">
                    <Loader />
                    Caricamento utenti...
                    </Flex>
                ),
                Empty: (<View><i>Nessun utente trovato</i></View>)
                }}
            />
            }
        </View> :
        <View>
            {props.type === 'all' ? 
            <p>Vuoi riassegnare tutti i task di {props.user} a <b>{operatoreValue}</b>?</p> :
            <p>Vuoi riassegnare i task selezionati di {props.user} a <b>{operatoreValue}</b>?</p>}
            <br/>
            <View textAlign="right">
                <Button
                    onClick={assignTask}
                    variation="primary"
                    disabled={loadingAssign}
                >
                    {loadingAssign ? <Loader/> : "Conferma"}
                </Button>
                {errorAssign && <span style={{"color": "red"}}><br/>Errore nell'assegnazione dei task!</span>}
            </View>
        </View>
    }
    </>
  );
};

export default TaskAssignModal;
